"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _numbers = require("../utils/numbers");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var lineHeight = 30;
var grayStyle = {
  1: {
    color: '#888'
  },
  2: {
    color: '#ccc'
  },
  3: {
    color: '#eee'
  }
};

var TimeScroll =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(TimeScroll, _PureComponent);

  function TimeScroll(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = TimeScroll.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateScrollTop();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.updateScrollTop();
  };

  _proto.bindElement = function bindElement(el) {
    this.element = el;
  };

  _proto.updateScrollTop = function updateScrollTop() {
    var _this2 = this;

    var value = this.props.value;
    if (!this.element) return;

    if (this.element.scrollTop !== lineHeight * value) {
      setTimeout(function () {
        if (_this2.element) _this2.scrollToValue();
      });
    }
  };

  _proto.scrollToValue = function scrollToValue() {
    var value = this.props.value;
    this.element.scrollTop = lineHeight * value;
  };

  _proto.handleClick = function handleClick(value) {
    this.props.onChange(value);
    this.element.scrollTop = lineHeight * value;
  };

  _proto.handleMouseLeave = function handleMouseLeave() {
    var value = Math.round(this.element.scrollTop / lineHeight);
    this.element.scrollTop = lineHeight * value;
  };

  _proto.handleScroll = function handleScroll() {
    var value = Math.round(this.element.scrollTop / lineHeight);
    if (value !== this.props.value) this.props.onChange(value);
  };

  _proto.renderItem = function renderItem(num) {
    var _this$props = this.props,
        ampm = _this$props.ampm,
        total = _this$props.total,
        value = _this$props.value;
    var text = num;
    if (ampm) text = ['am', 'pm'][num];else if (total === 12 && num === 0) text = '12';else if (num < 10) text = "0" + num;
    var className = (0, _styles.datepickerClass)(value === num && 'time-active');
    return _react.default.createElement("span", {
      key: num,
      className: className,
      style: grayStyle[Math.abs(value - num)],
      onClick: this.handleClick.bind(this, num)
    }, text);
  };

  _proto.render = function render() {
    var _this3 = this;

    var total = this.props.total;
    return _react.default.createElement("div", {
      ref: this.bindElement,
      className: (0, _styles.datepickerClass)('time-list'),
      onMouseLeave: this.handleMouseLeave,
      onScroll: this.handleScroll
    }, _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('pad')
    }), (0, _numbers.range)(total, 0).map(function (v) {
      return _this3.renderItem(v);
    }), _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('pad')
    }));
  };

  return TimeScroll;
}(_react.PureComponent);

TimeScroll.propTypes = {
  ampm: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  total: _propTypes.default.number,
  value: _propTypes.default.number.isRequired
};
TimeScroll.defaultProps = {
  total: 60
};
var _default = TimeScroll;
exports.default = _default;